import { render, staticRenderFns } from "./VDialogsPatC.vue?vue&type=template&id=13b0820e"
import script from "./VDialogsPatC.vue?vue&type=script&lang=js"
export * from "./VDialogsPatC.vue?vue&type=script&lang=js"
import style0 from "./VDialogsPatC.vue?vue&type=style&index=0&id=13b0820e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports